module.exports = __webpack_public_path__ + "img/logout.1c057d96.svg";